import React from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'
import SVG from '../SVG/SVG'
import Accordion from '../Accordion'
import Gtm from '../../../utils/gtm'
import { loggingEnabled } from '../../../utils/logging'

const useStyles = createUseStyles(theme => ({
  elFooter: {
    backgroundColor: theme.colors.blue,
  },
  containerFooter: {
    backgroundColor: theme.colors.blue,
    padding: '80px 0 0',
    display: 'block',
    backgroundSize: '100% auto',
    '& > div': {
      ...theme.wrappers.standard,
      margin: '0 auto',
      width: '100%',
      padding: '0 35px',
      maxWidth: 1490,
    },
  },
  containerFooterImg: {
    textAlign: 'center',
    '& img': {
      '@media (max-width: 700px)': {
        display: 'none',
      },
    },

    '@media (max-width: 700px)': {
      height: '180px',
      backgroundColor: 'transparent',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'left bottom',
      backgroundImage: 'url(/themes/thrifty/assets/images/Thrifty_Elements-Stripes2.png)',
      backgroundSize: 'auto 139px',
    },
  },
  gridle: {
    display: 'grid',
    gridTemplateColumns: `repeat(auto-fit, minmax(200px, 1fr))`,
    gridGap: '30px',
    marginBottom: '40px',
    '@media (max-width: 700px)': {
      gridTemplateColumns: '1fr',
      boxSizing: 'border-box',
      marginLeft: 15,
      marginRight: 15,
    },
  },
  hideonmobile: {
    '@media (max-width: 700px)': {
      display: 'none !important',
    },
  },
  mobilefooter: {
    '@media (min-width: 700px)': {
      display: 'none !important',
    },
  },
  text: {
    fontWeight: 300,
    color: '#fff',
    marginTop: '33px',
    fontSize: '12px',
    lineHeight: '18px',
    '& span': {
      fontFamily: 'TTRounds',
      fontWeight: 500,
      display: 'inline-block',
      marginRight: '0',
    },
    '& a': {
      color: '#fff',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
        textDecorationThickness: '1.4px',
        textUnderlineOffset: '0.2rem',
      },
    },
  },
  socialMedia: {
    fontWeight: 300,
    color: '#fff',
    marginTop: '33px',
    fontSize: '12px',
    lineHeight: '18px',
    '@media (min-width: 700px)': {
      paddingTop: 15,
    },
    '& span': {
      fontFamily: 'TTRounds',
      fontWeight: 500,
      display: 'block',
      marginRight: '0',
      marginBottom: '10px',
      '@media (min-width: 700px)': {
        display: 'none !important',
      },
    },
    '& a': {
      display: 'inline-flex',
      marginRight: 6,
      width: 28,
      height: 28,
      justifyContent: 'center',
      alignItems: 'center',
      '& svg': {
        fill: '#fff',
      },
      '&:hover svg': {
        fill: '#F8DD61',
      },
    },
  },
  title: {
    fontFamily: 'TTRounds',
    fontSize: '16px',
    fontWeight: 700,
    marginBottom: '20px',
    color: '#fff',
  },
  list: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    '& li': {
      marginBottom: 10,
      '& a': {
        fontSize: '12px',
        lineHeight: '12px',
        color: '#fff',
        fontWeight: 300,
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'underline',
          textDecorationThickness: '1.4px',
          textUnderlineOffset: '0.2rem',
        },
      },
    },
  },
  logoImg: {
    filter: 'brightness(0) invert(1)',
  },
  botFooter: {
    fontSize: '12px',
    color: 'white',
    paddingTop: '15px',
    borderTop: '1px solid #fff',
    fontWeight: 300,
    display: 'flex',
    '& div:nth-child(2)': {
      marginLeft: 'auto',
      opacity: 0.8,
    },
    '& a': {
      color: '#fff',
    },
  },
}))

export const Footer = ({ navLinks, WebSettings }) => {
  const classes = useStyles()
  const gtm = new Gtm(loggingEnabled)

  return (
    <footer className={classes.elFooter}>
      <div className={classes.containerFooter}>
        <div>
          <div className={classes.gridle}>
            <div>
              <img
                className={classes.logoImg}
                src="/themes/thrifty/assets/images/logo.png"
                width="120"
                height="43"
                alt="Thrifty"
              />
              <div className={classes.text}>
                <span>For Reservations</span>
                <br />
                <div dangerouslySetInnerHTML={{ __html: WebSettings.ForReservations }} />
              </div>
              <div className={classes.text} style={{ marginTop: '10px' }}>
                <span>Customer Service</span>
                <br />
                <div dangerouslySetInnerHTML={{ __html: WebSettings.CustomerServiceNumber }} />
              </div>
              <div className={classes.socialMedia} style={{ marginTop: '10px' }}>
                <span>Social Media</span>
                {WebSettings.Linkedin && (
                  <a
                    onClick={() => gtm.socialMediaClick('linkedin')}
                    href={WebSettings.Linkedin}
                    aria-label="Linkedin"
                  >
                    <SVG name={'Linkedin'} width={20} height={20} />
                  </a>
                )}
                {WebSettings.Facebook && (
                  <a
                    onClick={() => gtm.socialMediaClick('facebook')}
                    href={WebSettings.Facebook}
                    aria-label="Facebook"
                  >
                    <SVG name={'Facebook'} width={20} height={20} />
                  </a>
                )}
                {WebSettings.Twitter && (
                  <a
                    onClick={() => gtm.socialMediaClick('twitter')}
                    href={WebSettings.Twitter}
                    aria-label="Twitter"
                  >
                    <SVG name={'Twitter'} width={20} height={20} />
                  </a>
                )}
                {WebSettings.Youtube && (
                  <a
                    onClick={() => gtm.socialMediaClick('youtube')}
                    href={WebSettings.Youtube}
                    aria-label="Youtube"
                  >
                    <SVG name={'Youtube'} width={20} height={20} />
                  </a>
                )}
                {WebSettings.Instagram && (
                  <a
                    onClick={() => gtm.socialMediaClick('instagram')}
                    href={WebSettings.Instagram}
                    aria-label="Instagram"
                  >
                    <SVG name={'Instagram'} width={20} height={20} />
                  </a>
                )}
              </div>
            </div>
            {navLinks.map((nav, i) => (
              <div className={classes.hideonmobile} key={i}>
                <div className={classes.title}>{nav.header}</div>
                <ul className={classes.list}>
                  {nav.items.map((item, x) => (
                    <li key={x}>
                      <a href={item.href}>{item.text}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            <div className={classes.mobilefooter}>
              {navLinks.map((nav, outsideIndex) => (
                <Accordion key={`h-l-m-1-${outsideIndex}`} title={nav.header}>
                  <ul className={classes.list}>
                    {nav.items.map((item, insideIndex) => (
                      <li key={insideIndex}>
                        <a href={item.href}>{item.text}</a>
                      </li>
                    ))}
                  </ul>
                </Accordion>
              ))}
            </div>
          </div>
          <div className={classes.botFooter}>
            <div dangerouslySetInnerHTML={{ __html: WebSettings.FooterCopyRight }} />
            <div>{WebSettings.FooterACN}</div>
          </div>
        </div>
      </div>
      <div className={classes.containerFooterImg}>
        <img
          src="/themes/thrifty/assets/images/Thrifty_Elements-Stripes2.png"
          style={{ maxWidth: '100%', verticalAlign: 'bottom' }}
        />
      </div>
    </footer>
  )
}

Footer.propTypes = {
  headers: PropTypes.array,
  columns: PropTypes.array,
  socialLinks: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      href: PropTypes.string,
    }),
  ),
  ctaText: PropTypes.string,
  ctaURI: PropTypes.string,
  termsURI: PropTypes.string,
  privacyURI: PropTypes.string,
}

export default Footer
